import { library } from '@fortawesome/fontawesome-svg-core';

// 导入需要的图标
import {
  faSearch,
  faMagic,
  faUserCircle,
  faLightbulb,
  faCheck,
  faEdit,
  faTimes,
  faArrowRight,
  faChartLine,
  faLeaf,
  faUsers,
  faShoppingCart,
  faBrain,
  faBolt,
  faShieldAlt,
  faDatabase,
  faCalendarAlt,
  faBuilding,
  faStar,
  faFilter,
  faThLarge,
  faList,
  faImage,
  faBell,
  faBars,
  faEye,
  faDownload,
  faBookmark,
  faCheckCircle,
  faMapMarkerAlt,
  faCloudDownloadAlt,
  faChevronUp,
  faClockRotateLeft,
  faRobot
} from '@fortawesome/free-solid-svg-icons';

import {
  faTwitter,
  faGithub,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons';

import {
  faBookmark as farBookmark,
  faCalendarAlt as farCalendarAlt
} from '@fortawesome/free-regular-svg-icons';

// 将图标添加到库中
library.add(
  // Solid icons
  faSearch,
  faMagic,
  faUserCircle,
  faLightbulb,
  faCheck,
  faEdit,
  faTimes,
  faArrowRight,
  faChartLine,
  faLeaf,
  faUsers,
  faShoppingCart,
  faBrain,
  faBolt,
  faShieldAlt,
  faDatabase,
  faCalendarAlt,
  faBuilding,
  faStar,
  faFilter,
  faThLarge,
  faList,
  faImage,
  faBell,
  faBars,
  faEye,
  faDownload,
  faBookmark,
  faCheckCircle,
  faMapMarkerAlt,
  faCloudDownloadAlt,
  faChevronUp,
  faClockRotateLeft,
  faRobot,
  
  // Brand icons
  faTwitter,
  faGithub,
  faLinkedin
);

// Add regular icons separately
library.add(farBookmark as any, farCalendarAlt as any);